import clamp from "lodash/clamp";
import React from "react";

export default class ScrollLockDiv extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onScrollHandler = this.onScrollHandler.bind(this);
    }

    componentDidMount() {
        this._element.addEventListener("wheel", this.onScrollHandler, false);
    }

    componentWillUnmount() {
        this._element.removeEventListener("wheel", this.onScrollHandler, false);
    }

    onScrollHandler(event) {
        if (!this._element) {
            return true;
        }

        // Find a scrollable element in the event path, but make sure we never go any higher than this component's
        // root element... we only want to allow scrolling in the children of this component.
        for (let target = event.target; target; target = target.parentElement) {
            if (target.scrollHeight !== target.clientHeight) {
                const scrollDelta = event.deltaY;
                const { scrollTop, scrollHeight } = target;
                target.scrollTop = clamp(
                    scrollTop + scrollDelta,
                    0,
                    scrollHeight
                );
            }
            if (target === this._element) {
                break;
            }
        }

        return ScrollLockDiv.cancelScrollEvent(event);
    }

    static cancelScrollEvent(event) {
        // prevent other handlers on this element from firing
        event.stopImmediatePropagation();

        // prevent the event from bubbling any farther up the DOM tree
        event.stopPropagation();

        // prevent the default action... we're handling everything manually!
        event.preventDefault();

        return false;
    }

    render() {
        return (
            <div ref={element => (this._element = element)} {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ScrollLockDiv.js